import { render, staticRenderFns } from "./HelmetCertificationBadges.vue?vue&type=template&id=2c17c876&scoped=true"
import script from "./HelmetCertificationBadges.vue?vue&type=script&lang=js"
export * from "./HelmetCertificationBadges.vue?vue&type=script&lang=js"
import style0 from "./HelmetCertificationBadges.vue?vue&type=style&index=0&id=2c17c876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17c876",
  null
  
)

export default component.exports